import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { RequestStatus, DocumentSegment, NGXLogger } from '@app/shared';
import { DocumentSegmentService } from '@app/core';
import {
  DocumentSegmentActionTypes,
  GetDocumentSegments,
  GetDocumentSegmentsSuccess,
  GetDocumentSegmentsFailure,

  GetDocumentSegment,
  GetDocumentSegmentSuccess,
  GetDocumentSegmentFailure,

  SetDocumentSegment,
  SetDocumentSegmentSuccess,
  SetDocumentSegmentFailure,

  UpdateDocumentSegment,
  UpdateDocumentSegmentSuccess,
  UpdateDocumentSegmentFailure,

  SetDocumentSegmentLock,
  SetDocumentSegmentLockSuccess,
  SetDocumentSegmentLockFailure,

} from '../actions/documentSegment.actions';


@Injectable()
export class DocumentSegmentEffects {

  constructor(
    private actions: Actions,
    private documentSegmentService: DocumentSegmentService,
    private router: Router,
    private logger:NGXLogger
  ) { }

    @Effect()
    GetDocumentSegments: Observable<any> = this.actions
        .ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS)
        .debounceTime(10)
        .map((action: GetDocumentSegments) => action.payload)
        .switchMap(payload => {
          return this.documentSegmentService.getDocumentSegments(payload.searchCriteria.keyword)
            .map((result) => {

              // init documentSegment members
              result.data.map(documentSegment => documentSegment.members = []);

              return new GetDocumentSegmentsSuccess({documentSegments:result.data})
            })
            .catch((error) => {
              return Observable.of(new GetDocumentSegmentsFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetDocumentSegmentsSuccess: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_SUCCESS),
      tap((result) => {
        this.logger.debug(' Get Document Success')
      })
    );

    @Effect({ dispatch: false })
    GetDocumentSegmentsFailure: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENTS_FAILURE)
    );


    // PAGE DETAILED INFORMATION
    @Effect()
    GetDocumentSegment: Observable<any> = this.actions
        .ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT)
        .map((action: GetDocumentSegment) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.documentSegmentService.getDocumentSegment(payload.documentSegment.uuid)
            .map((result) => {
              //this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              let ds:DocumentSegment = result.data[0];
              return new GetDocumentSegmentSuccess({documentSegment:ds})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new GetDocumentSegmentFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetDocumentSegmentSuccess: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT_SUCCESS),
      tap((result) => {
        //this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetDocumentSegmentFailure: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.GET_DOCUMENT_SEGMENT_FAILURE),
    );



    @Effect()
    UpdateDocumentSegment: Observable<any> = this.actions
        .ofType(DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT)
        .debounceTime(10)
        .map((action: GetDocumentSegments) => action.payload)
        .switchMap(payload => {
          return this.documentSegmentService.updateDocumentSegment(payload.documentSegment)
            .map((result) => {

              if(result.data){
                let rs : RequestStatus = new RequestStatus();
                rs.code = result.code;
                rs.msg = `Page has been saved`;

                return new UpdateDocumentSegmentSuccess({documentSegment:result.data,successStatus:rs})
              }else{
                let rs : RequestStatus = new RequestStatus();
                rs.msg = result.message;

                return new UpdateDocumentSegmentFailure({ errorStatus: rs });
              }

            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.error.message;
              //rs.msg = "Sorry unable to save the DocumentSegment."

              return Observable.of(new UpdateDocumentSegmentFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    UpdateDocumentSegmentSuccess: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    UpdateDocumentSegmentFailure: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.UPDATE_DOCUMENT_SEGMENT_FAILURE)
    );


    @Effect()
    SetDocumentSegmentLock: Observable<any> = this.actions
        .ofType(DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK)
        .debounceTime(10)
        .map((action: GetDocumentSegments) => action.payload)
        .switchMap(payload => {
          return this.documentSegmentService.setDocumentSegmentLock(payload.documentSegment.uuid,payload.documentSegment.lockStatus)
            .map((result) => {

              if(result.data && result.data.length && result.data[0].type && (result.data[0].type === "DATABASE_EXCEPTION")){
                let rs : RequestStatus = new RequestStatus();
                rs.msg = "Unable to lock the page";

                return new SetDocumentSegmentLockFailure({ errorStatus: rs });
              }else{

                let rs : RequestStatus = new RequestStatus();
                rs.code = result.code;
                let status :string = payload.documentSegment.lockStatus === "T"?'locked':'unlocked';
                rs.code = result.code;
                rs.msg = `Page has been ${status}`;
                // update the document segment
                if(payload.job){

                  for(let ds of payload.job.documentSegments){
                    if(ds.uuid === payload.documentSegment.uuid){
                      ds.lockStatus = payload.documentSegment.lockStatus;
                      for(let o of ds.publicOffers){
                          o.lockStatus = payload.documentSegment.lockStatus;
                      }

                      for(let oa of ds.offerAllocation){
                        for(let o of oa.publicOffers){
                          o.lockStatus = payload.documentSegment.lockStatus;
                        }
                      }

                    }
                  }
                }
                return new SetDocumentSegmentLockSuccess({documentSegment:result.data,successStatus:rs})
              }

            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = "Unable to lock the page";
              //rs.msg = "Sorry unable to save the DocumentSegment."

              return Observable.of(new SetDocumentSegmentLockFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    SetDocumentSegmentLockSuccess: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_SUCCESS),
      tap((result) => {
        //this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    SetDocumentSegmentLockFailure: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_LOCK_FAILURE)
    );


    // SETTING CURRENT DocumentSegment
    //@Effect()
    /*SetDocumentSegment: Observable<any> = this.actions
        .ofType(DocumentSegmentActionTypes.SET_DOCUMENTSEGMENT)
        .map((action: GetDocumentSegments) => action.payload)
        .switchMap(payload => {
          return this.documentSegmentService.getDocumentSegment(payload.documentSegment)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetDocumentSegmentSuccess({selectedDocumentSegment:payload.documentSegment})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetDocumentSegmentFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetDocumentSegmentSuccess: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_SUCCESS),
      tap((result) => {

        //this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetDocumentSegmentFailure: Observable<any> = this.actions.pipe(
      ofType(DocumentSegmentActionTypes.SET_DOCUMENT_SEGMENT_FAILURE)
    );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/documentSegment.effects.ts